import { Permissions } from "./consts";

export const invalidCharacters = /^[^<>&"'\\/:*?|]*$/;
export const pageSizes = [10, 20, 50];
export const commonDebounceDelay = 400;

export const isPathIncluded = (str: string) => {
  return window.location.pathname.includes(str);
};

export const generateQuery = (queries: object) => {
  return Object.getOwnPropertyNames(queries)
    .reduce((prev, curr) => {
      prev.push(
        encodeURIComponent(curr) + "=" + encodeURIComponent(queries[curr]),
      );
      return prev;
    }, [] as string[])
    .join("&");
};

export const hasPermission = (
  permission: Permissions,
  permissions: string[],
) => {
  return permissions.includes(permission);
};

export const isGlobalAdmin = (permissions) => {
  return permissions.includes(Permissions.MANAGE);
};

const SELECTED_COMPANY = "selectedCompanyId";

export const setCompanyToLocalStorage = (value: number | string) => {
  localStorage.setItem(SELECTED_COMPANY, String(value));
};

export const getCompanyFromLocalStorage = () => {
  return localStorage.getItem(SELECTED_COMPANY);
};

export function removeTrailingWildcard(search?: string): string | undefined {
  const trimmed = search?.trim() ?? "";
  if (trimmed === "") {
    return undefined;
  }

  const withoutPostfixWildcard = trimmed.endsWith("*")
    ? trimmed.slice(0, -1).trim()
    : trimmed;

  if (withoutPostfixWildcard === "") {
    return undefined;
  }

  return withoutPostfixWildcard;
}
